import { useTranslation } from 'react-i18next'

import { Box } from '@mui/material'

import { Testimonial } from '@pages/LandingPage/components/Testimonial'

import { containerSx, contentSx, testimonialContainerSx } from './styles'

const Testimonial1Section = () => {
  const { t } = useTranslation()

  return (
    <Box data-testid="features-testimonial-1-section" sx={containerSx}>
      <Box sx={contentSx}>
        <Testimonial
          variant="dark"
          testimonialText={t(
            'This platform is extremely helpful - just finding partners and having the same conversations with 3 or 4 different people just to get the bottom of what I’m looking for is very, very time-consuming where as your marketplace just cuts through all tape, and gets us in contact with the right people…it saves me so much time and I’m very grateful.'
          )}
          personName="Harry L."
          personPosition={t('CIO')}
          containerSx={testimonialContainerSx}
        />
      </Box>
    </Box>
  )
}

export { Testimonial1Section }
